import React from 'react';
import { useIntl } from 'react-intl';
import { formatClock, formatDuration } from '../utils/timeZone';
import { StatusMessage } from './StatusMessage';

const TripItem = ({ trip, timeZone, selected, onPick }) => {
  const { formatMessage } = useIntl();
  const classes = ['request-video-trip'];
  if (selected) classes.push('selected');
  let driver = formatMessage({ id: 'requestVideo_trip_noDriver' });
  if (trip.driverName) driver = formatMessage({ id: 'requestVideo_trip_driver' }, { name: trip.driverName });

  return (
    <li>
      <button
        type="button"
        aria-pressed={selected}
        className={classes.join(' ')}
        onClick={() => onPick(trip)}
      >
        <strong>
          {formatClock(trip.startMs, timeZone)} - {formatClock(trip.endMs, timeZone)}
        </strong>
        <span>{formatDuration(trip.durationMs)}</span>
        <span>{driver}</span>
      </button>
    </li>
  );
};

export const TripList = ({ query, timeZone, selectedId, onPick }) => {
  if (query.isLoading) return <StatusMessage id="requestVideo_trips_loading" />;
  if (query.isError) {
    return <StatusMessage id="requestVideo_trips_error" tone="error" onRetry={query.refetch} />;
  }
  if (query.trips.length === 0) return <StatusMessage id="requestVideo_trips_none" />;

  return (
    <ul className="request-video-trips">
      {query.trips.map((trip) => (
        <TripItem
          key={trip.id}
          trip={trip}
          timeZone={timeZone}
          selected={trip.id === selectedId}
          onPick={onPick}
        />
      ))}
    </ul>
  );
};
